import { z } from "zod";

/** 100 pages × 24 per page = 2,400 rows; past that, move to cursor pagination. */
export const MAX_PAGE = 100;

/** `?page=` query value. A huge page makes Postgres skip that many rows (OFFSET). */
export const pageSchema = z.coerce.number().int().min(1).max(MAX_PAGE);

/** Staff dashboards list more rows than a public page; matches the other operator caps. */
export const MAX_OPERATOR_PAGE = 1000;

export const operatorPageSchema = z.coerce
  .number()
  .int()
  .min(1)
  .max(MAX_OPERATOR_PAGE);
